import { useEffect } from "react";

import {
  getPlannerTokenSharing,
  getTenantInfo,
} from "../services/apiSystemSettings";
import { localStorageInstance } from "../utils/localStorage";
import { getResponseData } from "./response";
import { hasQueryValue, useMappedQuery } from "./queryUtils";

function persistPlannerTokenSharing(value) {
  localStorageInstance.setItem({
    key: "planner_token_sharing_enabled",
    value,
  });
}

export function useTenant() {
  const query = useMappedQuery({
    queryKey: ["tenant-details"],
    queryFn: getTenantInfo,
  });

  useEffect(() => {
    persistPlannerTokenSharing(
      getResponseData(query.data)?.planner_token_sharing_enabled
    );
  }, [query.data]);

  return query;
}

export function usePlannerTokenSharing(domain) {
  const query = useMappedQuery({
    queryKey: ["planner-token-sharing"],
    queryFn: () => getPlannerTokenSharing(domain),
    enabled: hasQueryValue(domain),
  });

  useEffect(() => {
    persistPlannerTokenSharing(query.data?.data?.enabled);
  }, [query.data]);

  return query;
}
